var map = {
	"./Avatar-Yoga-Festival-Stage-View.jpeg": 36,
	"./Chillary Festival_Stage-View.jpeg": 627,
	"./Chillary-Festival_In-The-Mix.jpg": 595,
	"./Chillary-Festival_Live-Set.jpeg": 677,
	"./Mindsex.webp": 155,
	"./Rotterdam-Walk.jpeg": 646,
	"./Royal-Opera-House-Muscat.jpeg": 616,
	"./Sacred-Psychronicles-Party.jpeg": 40,
	"./Smoky.webp": 822,
	"./Soria_Gathering.png": 141,
	"./Studio-Time.jpeg": 578,
	"./Vibronica-Festival-2021.jpeg": 628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 346;